import React, { useState } from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import LiveTooltip from 'live/components/ui/tooltip'

export interface ITab {
    label: string
    view: JSX.Element
    disabled?: boolean
    tooltipMessage?: string
}

interface IProps {
    tabs: ITab[]
}

const CustomTabs = ({ tabs }: IProps): JSX.Element => {
    const [active, setActive] = useState(0)

    const RendeLiTooltip = ({ tooltipMessage, index, disabled, label }: any): JSX.Element => {
        return (
            <LiveTooltip position="top" content={i18n(tooltipMessage)}>
                <StyledLi className={`${active === index ? 'active' : ''}  ${disabled ? 'disabled' : ''}  `}>
                    <div onClick={() => setActive(index)}>{i18n(label)}</div>
                </StyledLi>
            </LiveTooltip>
        )
    }

    const RendeLiDefault = ({ index, disabled, label }: any): JSX.Element => {
        return (
            <StyledLi className={`${active === index ? 'active' : ''}  ${disabled ? 'disabled' : ''}  `}>
                <div onClick={() => setActive(index)}>{i18n(label)}</div>
            </StyledLi>
        )
    }

    return (
        <StyledTabs>
            <StyledUl>
                {tabs.map(({ label, disabled, tooltipMessage }: ITab, index) => {
                    return (
                        <React.Fragment key={index}>
                            {tooltipMessage ? (
                                <RendeLiTooltip
                                    index={index}
                                    tooltipMessage={tooltipMessage}
                                    disabled={disabled}
                                    label={label}
                                />
                            ) : (
                                <RendeLiDefault index={index} disabled={disabled} label={label} />
                            )}
                        </React.Fragment>
                    )
                })}
            </StyledUl>

            {tabs.map(({ view }: ITab, index) => {
                if (active !== index) return undefined

                return <StyledTabContent key={index}>{view}</StyledTabContent>
            })}
        </StyledTabs>
    )
}

export default React.memo(CustomTabs)

interface StyleLiPros {
    onClick(): void
    key: number
    isActive: boolean
}

const StyledTabs = styled.div`
    height: 100%;
`
const StyledUl = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    background-color: ${({ theme }) => theme['gray-100']};

    .disabled {
        cursor: not-allowed;

        div {
            pointer-events: none;
        }
    }

    .active {
        background-color: ${({ theme }) => theme['gray-0']};
        font-weight: 600;
    }
`

const StyledLi = styled.li`
    flex: 1;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    color: ${({ theme }) => theme['gray-800']};

    div {
        padding: 15px 0;
    }
`

const StyledTabContent = styled.div`
    padding: 0;
    overflow-y: auto;
    height: calc(100% - 47.78px);

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme['gray-500']};
        border-radius: 10px;
    }
`
